module.exports = __webpack_public_path__ + "static/carousel_light-53b8bdd309e34cf70c85fcf5bed0a6a5.gif";